module.exports = __webpack_public_path__ + "img/default-sensor-on.baf34a30.svg";